// Pure React SVG shape renderer — no dangerouslySetInnerHTML
export function ShapeSVG({ shapeId, color, stroke }) {
  const s = stroke || darken(color);

  switch (shapeId) {
    case 'circle':
      return (
        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
          <circle cx="100" cy="100" r="85" fill={color} stroke={s} strokeWidth="4" />
        </svg>
      );
    case 'square':
      return (
        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
          <rect x="20" y="20" width="160" height="160" rx="4" fill={color} stroke={s} strokeWidth="4" />
        </svg>
      );
    case 'triangle':
      return (
        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
          <polygon points="100,15 185,180 15,180" fill={color} stroke={s} strokeWidth="4" />
        </svg>
      );
    case 'rectangle':
      return (
        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
          <rect x="15" y="50" width="170" height="100" rx="4" fill={color} stroke={s} strokeWidth="4" />
        </svg>
      );
    case 'oval':
      return (
        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
          <ellipse cx="100" cy="100" rx="90" ry="60" fill={color} stroke={s} strokeWidth="4" />
        </svg>
      );
    case 'semicircle':
      return (
        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
          <path d="M 15 140 A 85 85 0 0 1 185 140 Z" fill={color} stroke={s} strokeWidth="4" />
        </svg>
      );
    case 'pentagon':
      return (
        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
          <polygon points="100,15 190,75 155,175 45,175 10,75" fill={color} stroke={s} strokeWidth="4" />
        </svg>
      );
    case 'hexagon':
      return (
        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
          <polygon points="55,15 145,15 190,100 145,185 55,185 10,100" fill={color} stroke={s} strokeWidth="4" />
        </svg>
      );
    case 'diamond':
      return (
        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
          <polygon points="100,10 185,100 100,190 15,100" fill={color} stroke={s} strokeWidth="4" />
        </svg>
      );
    case 'star':
      return (
        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
          <polygon points="100,10 125,75 195,75 140,120 160,185 100,145 40,185 60,120 5,75 75,75" fill={color} stroke={s} strokeWidth="4" />
        </svg>
      );
    case 'heart':
      return (
        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
          <path d="M100,180 C60,140 10,110 10,65 C10,30 40,10 70,10 C85,10 95,20 100,30 C105,20 115,10 130,10 C160,10 190,30 190,65 C190,110 140,140 100,180Z" fill={color} stroke={s} strokeWidth="4" />
        </svg>
      );
    default:
      return (
        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
          <circle cx="100" cy="100" r="85" fill={color} stroke={s} strokeWidth="4" />
        </svg>
      );
  }
}

function darken(hex) {
  const num = parseInt(hex.replace('#', ''), 16);
  const r = Math.max(0, (num >> 16) - 30);
  const g = Math.max(0, ((num >> 8) & 0x00ff) - 30);
  const b = Math.max(0, (num & 0x0000ff) - 30);
  return `#${(r << 16 | g << 8 | b).toString(16).padStart(6, '0')}`;
}
